import { html } from "lit-html";
import type { View, App } from "../app.js";
import { api } from "../api.js";
import type { Opportunity } from "../types.js";
import { oppItem, oppLabel, sectionHead } from "../components.js";
import { moneyShort } from "../format.js";

interface Data { items: Opportunity[] }
type Kind = Opportunity["type"] | "all";
let kind: Kind = "all";
let search = "";
let shown = 60;

export const opps: View<Data> = {
  title: () => "Opportunities",
  filters: ["manager", "rep"],
  async load(app) {
    shown = 60;
    return { items: (await api.opportunities(app.q())).items };
  },
  render(app: App, d) {
    const kinds: Kind[] = ["all", "lapsed", "declining", "open_quote", "low_conversion", "cold_county"];
    const count = (k: Kind) => (k === "all" ? d.items.length : d.items.filter((o) => o.type === k).length);
    const s = search.trim().toLowerCase();
    const list = d.items.filter((o) => (kind === "all" || o.type === kind) && (!s || `${o.title} ${o.repName} ${o.countyLabel ?? ""}`.toLowerCase().includes(s)));
    const dollars = list.filter((o) => o.type !== "low_conversion").reduce((a, o) => a + o.value, 0);
    return html`
      <div class="row" style="margin-bottom:14px;flex-wrap:wrap;gap:12px">
        <div class="seg" role="group" aria-label="Type">
          ${kinds.map((k) => html`<button aria-pressed=${kind === k} @click=${() => { kind = k; shown = 60; app.render(); }}>${k === "all" ? "All" : oppLabel(k as Opportunity["type"]).replace(" customer", "").replace(" county", "")} <span class="muted">${count(k)}</span></button>`)}
        </div>
        <span class="spacer"></span>
        <input class="input" style="width:240px" type="search" placeholder="Search customer, rep, county" .value=${search}
          @input=${(e: Event) => { search = (e.target as HTMLInputElement).value; shown = 60; app.render(); }}>
      </div>
      <section class="glass card">
        ${sectionHead(`${list.length} to bring up`, `${moneyShort(dollars)} in lost, slipping or open business`)}
        ${list.length ? list.slice(0, shown).map((o) => oppItem(o, (f) => app.go("map", f))) : html`<div class="empty-state">Nothing matches.</div>`}
        ${list.length > shown ? html`<div class="row mt" style="justify-content:center"><button class="btn" @click=${() => { shown += 60; app.render(); }}>Show more (${list.length - shown} left)</button></div>` : ""}
      </section>
      <p class="muted small mt">Lapsed: bought $2,500+ in the prior year, nothing in the last 12 months. Declining: down 40%+ year over year. Open quote: still open after 14 days. Low conversion: win rate 15+ points under average with 5+ decided quotes. Cold county: under 25% of last year's pace. Thresholds live in config/settings.json.</p>`;
  },
};
